/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * access/refresh-токены
 */
export interface TokenModel { 
    /**
     * access-токен
     */
    token?: string;
    /**
     * refresh-токен
     */
    refreshToken?: string;
}

